import { useEffect, useState } from 'react';

// Delays propagation of a fast-changing value so query keys/requests don't
// churn per keystroke. Inputs that already debounce (SearchBox via
// textChangeDelay) don't need this — use it where raw state feeds a query key.
const useDebounce = (value, delayMs = 350) => {
    const [debounced, setDebounced] = useState(value);

    useEffect(() => {
        const timer = setTimeout(() => setDebounced(value), delayMs);
        return () => clearTimeout(timer);
    }, [value, delayMs]);

    return debounced;
};

export default useDebounce;
